export const SET_BOOKING_DETAILS = "SET_BOOKING_DETAILS";
export const SET_CITIES = "SET_CITIES";
export const SET_NEXT_DESTINATIONS = "SET_NEXT_DESTINATIONS";
export const SET_LOADING = "SET_LOADING";
export const SET_CITIES_DEPARTURES = "SET_CITIES_DEPARTURES";